import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { listRemovalError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (list) =>
    present(
      repository
        .removeList(list)
        .then(() => list)
        .catch((error) =>
          Promise.reject({ error: { ...listRemovalError, error }, list }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
